import { ChangeDetectionStrategy, Component, Input, signal } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { TemplateObservable } from '@bazis/shared/classes/template-observable';
import { BazisControlValueAccessor } from '@bazis/form/components/control-value-accessor.component';

export interface SwitcherData {
    value: any;
    name: string;
}

@UntilDestroy()
@Component({
    selector: 'bazis-switcher',
    templateUrl: './switcher.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class BazisSwitcherComponent extends BazisControlValueAccessor {
    // 1й эл-т массива для false, 2й для true - Важно!
    @Input() switchData: SwitcherData[] = [
        {
            value: false,
            name: '',
        },
        {
            value: true,
            name: '',
        },
    ];

    // Один из зарезервированных темой цветов (primary, secondary, danger, success, warning, action, info, brand, tertiary)
    @Input() color: string = null;

    disabled = signal<boolean>(false);

    value: TemplateObservable<boolean> = new TemplateObservable<boolean>(false);

    public writeValue(value): void {
        if (!this.ngControl.control) return;
        this.value.set(this.switchData.findIndex((v) => v.value === value) > 0);
    }

    public setDisabledState(isDisabled: boolean): void {
        this.disabled.set(isDisabled);
    }

    toggleValue() {
        this.value.set(!this.value._);
        this.ngControl.control.setValue(this.switchData[+this.value._].value);
        this.markAsTouched();
    }
}
